import styled from 'styled-components';

export const Title = styled.h1.attrs({
  className: 'mt-2',
})``;

export const TitleLabel = styled.h2.attrs({
  className: 'my-4',
})`
  font-size: 1.5rem;
`;

export const Summary = styled.p.attrs({
  className: 'mb-1 fw-light',
})``;
